import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import React, { ReactElement } from 'react';

import { numberFormat } from '../../../utils';
import RectButton from '../DesignSystem/RectButton/RectButton';
import styles from './CallToActionButton.module.scss';

export interface ICTASelectedData {
  option: string;
  price: number | string;
}

interface ICallToActionButtonProps {
  /**
   * 상단 테두리?
   */
  border?: boolean;
  buttonType?: 'button' | 'submit';
  /** 버튼 종류.
   * Primary(default) - 분홍
   * Secondary - 분홍, 라인
   * */
  children: string | ReactElement;
  className?: string;
  buttonClassName?: string;
  /** PDP 또는 RDP 에서 보여지는 선택한 상품 옵션과 가격 정보 */
  data?: ICTASelectedData;
  disabled?: boolean;
  isPrimary?: boolean;
  /**
   * 상단 그림자?
   */
  shadow?: boolean;
  /** CTA 버튼의 위치.
   * fixed - 하단 고정
   * static - 페이지 중간쯤 위치
   */
  type: 'fixed' | 'static';
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CallToActionButton: React.RefForwardingComponent<HTMLDivElement, ICallToActionButtonProps> = (
  {
    border,
    buttonType = 'button',
    children,
    className,
    data,
    isPrimary = true,
    shadow = true,
    type,
    disabled,
    onClick,
    buttonClassName,
  },
  ref,
) => {
  const isFixed = type === 'fixed';

  return (
    <div
      className={clsx(
        styles.container,
        isFixed && styles.bottom,
        isFixed && border && styles.bottomBorder,
        isFixed && shadow && styles.bottomShadow,
        className,
      )}
      ref={ref}
    >
      <div className={styles.wrap}>
        {data && (
          <div className={styles.infoWrap}>
            <span className={styles.option}>{data.option}</span>
            <span className={styles.price}>{numberFormat(data.price)}원</span>
          </div>
        )}
        {isPrimary ? (
          <RectButton.Primary
            as="button"
            className={clsx(styles.cta, data && styles.ctaWithData, buttonClassName)}
            disabled={disabled}
            type={buttonType}
            onClick={onClick}
          >
            {children}
          </RectButton.Primary>
        ) : (
          <RectButton.Blue
            as="button"
            disabled={disabled}
            className={clsx(styles.cta, buttonClassName)}
            type={buttonType}
            onClick={onClick}
          >
            {children}
          </RectButton.Blue>
        )}
      </div>
    </div>
  );
};

export default observer(CallToActionButton, { forwardRef: true });
